module.exports = __webpack_public_path__ + "static/img/pic_12@2x.a47c7480.png";